module.exports = __webpack_public_path__ + "media/images/icons/repost_black-ad843e10e574d60a372a24d1372baabb.svg";